<template>
  <div class="resource-selection">
    <div class="modal-header" style="will-change: transform">
      <div class="row">
        <div class="col-12">
          <h3>
            <p>Select Resources</p>
            <p>
              <small
                >Select the calendars you want to see, drag them up or down to change the order. Toggle desktop
                notifications for the user with the switch on the right.</small
              >
            </p>
          </h3>
        </div>
      </div>
    </div>

    <form v-on:submit.prevent>
      <div class="m-t">
        <div class="row">
          <div class="offset-1 col-3">
            <button class="badge label-primary btn" id="resourcesSelectAll" type="button" v-on:click="selectAll">
              Select All
            </button>
          </div>
          <div class="col-4">
            <button class="badge label-primary btn" id="resourcesSelectNone" type="button" v-on:click="selectNone">
              Select None
            </button>
          </div>
          <div class="col-3">
            <b>Desktop Notifications</b>
          </div>
        </div>
        <hr />
        <div ref="list" class="resource-selection-list">
          <div
            class="row grab-handle resource-selection-row"
            v-for="resource in allResources"
            :key="resource._id"
            :data-id="resource._id"
          >
            <div class="col-9">
              <div class="form-check">
                <span>
                  <i class="fa fa-ellipsis-v">&nbsp;&nbsp;</i>
                </span>
                <input
                  class="resource-selection-checkbox"
                  type="checkbox"
                  :id="'resourceMenu-' + resource.name"
                  :value="resource.name"
                  v-model="resource.selected"
                />
                <label :for="'resourceMenu-' + resource.name">&nbsp; {{ resource.name }}</label>
              </div>
            </div>
            <div class="col-3">
              <div class="custom-control custom-switch">
                <input
                  class="custom-control-input"
                  :id="'notify-checkbox-' + resource.name"
                  type="checkbox"
                  :checked="resource.notify"
                  :disabled="resource.isAssigned"
                  v-on:change="toggleNotifications(resource)"
                />
                <label class="custom-control-label" :for="'notify-checkbox-' + resource.name"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="modal-footer">
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary" id="resourceSelectionOkButton" title="Ok" v-on:click="ok">Ok</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs'

import notificationService from '../../resources/service/notificationService.js'
import resourceSelectionService from '../service/resourceSelectionService.js'

// The resource-selection slide-out (step 35b of #614). This is `ResourceSelectionCtrl` + its pug as
// one Vue component, rendered by SliderHost like the booking and incomplete-bookings slide-outs. It
// was the last Angular view and the last caller of `$aside`.
//
// `resourceSelectionService` returns the same array every caller sees; the component keeps that
// reference and adds `notify` to each resource, so a drag reorders the same array the service saves.
export default {
  name: 'ResourceSelectionSlider',
  data() {
    return {
      allResources: [],
      sortable: null,
    }
  },
  async created() {
    const resources = await resourceSelectionService.getResources()
    // The resources are reactive (`reactive` in the service), and Vue 3's proxy reactivity sees a
    // new key without `$set`, so the toggle re-renders on a plain assignment.
    resources.forEach(resource => {
      resource.notify = notificationService.notificationsConfigured(resource.name)
    })
    this.allResources = resources
  },
  mounted() {
    // `ng-sortable`'s conf: the same animation/handle/forceFallback, and the same "persist the
    // order when the drag ends". Sortable moves the DOM node; the array is reordered to match so
    // the saved order is the one on screen.
    this.sortable = Sortable.create(this.$refs.list, {
      animation: 350,
      handle: '.grab-handle',
      forceFallback: true,
      onEnd: ({ oldIndex, newIndex }) => {
        const [moved] = this.allResources.splice(oldIndex, 1)
        this.allResources.splice(newIndex, 0, moved)
        resourceSelectionService.setAllResources()
      },
    })
  },
  beforeUnmount() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    selectNone() {
      this.allResources = resourceSelectionService.selectNone()
    },
    selectAll() {
      this.allResources = resourceSelectionService.selectAll()
    },
    toggleNotifications(resource) {
      resource.notify = notificationService.toggleNotifications(resource.name)
    },
    // Was `$uibModalInstance.close(1)`; the slide-out promise resolves with the same value.
    ok() {
      this.$emit('close', 1)
    },
  },
}
</script>
